module.exports = __webpack_public_path__ + "static/img/26834.05816e0.png";


//////////////////
// WEBPACK FOOTER
// ./src/common/images/productCenter/dxzg/26834.png
// module id = 0BTY
// module chunks = 0